import React from 'react';
import { Check, Star, Zap } from 'lucide-react';
import { Button } from '../ui/button';
import { Card, CardContent, CardHeader, CardTitle } from '../ui/card';
import { Badge } from '../ui/badge';
import { pricing, testimonials } from '../../data/mock';

const Pricing = () => {
  return (
    <section id="precios" className="py-24 bg-white">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        {/* Header */}
        <div className="text-center max-w-3xl mx-auto mb-16">
          <Badge variant="outline" className="mb-4 px-4 py-1 text-blue-600 border-blue-200 bg-blue-50">
            Precios
          </Badge>
          <h2 className="text-3xl sm:text-4xl lg:text-5xl font-bold text-slate-800 mb-6">
            Inversión en tu{' '}
            <span className="text-blue-600">Éxito Académico</span>
          </h2>
          <p className="text-lg text-slate-600">
            Precios accesibles con soluciones de calidad. Paga solo por lo que necesitas.
          </p>
        </div>

        <div className="grid lg:grid-cols-2 gap-12 items-start">
          {/* Pricing Card */}
          <div className="relative">
            <div className="absolute inset-0 bg-gradient-to-br from-blue-500 to-cyan-500 rounded-3xl blur-2xl opacity-10" />
            <Card className="relative border-2 border-blue-100 shadow-xl overflow-hidden">
              <div className="absolute top-0 right-0 w-32 h-32 bg-blue-50 rounded-bl-full" />
              <CardHeader className="relative pb-2">
                <div className="flex items-center justify-between">
                  <Badge className="bg-blue-600 text-white px-3 py-1">
                    <Zap className="w-3 h-3 mr-1" />
                    Más Popular
                  </Badge>
                </div>
                <CardTitle className="text-2xl font-bold text-slate-800 mt-4">
                  Resolución de Exámenes
                </CardTitle>
              </CardHeader>
              <CardContent>
                <div className="mb-8">
                  <div className="flex items-baseline gap-2">
                    <span className="text-5xl font-bold text-blue-600">
                      {pricing.currency}{pricing.price}
                    </span>
                    <span className="text-slate-500">/{pricing.unit}</span>
                  </div>
                  <p className="text-slate-600 mt-2">
                    Incluye {pricing.questions} problemas resueltos
                  </p>
                </div>

                <ul className="space-y-4 mb-8">
                  {pricing.includes.map((item, index) => (
                    <li key={index} className="flex items-center gap-3">
                      <div className="w-6 h-6 rounded-full bg-emerald-100 text-emerald-600 flex items-center justify-center flex-shrink-0">
                        <Check className="w-4 h-4" />
                      </div>
                      <span className="text-slate-700">{item}</span>
                    </li>
                  ))}
                </ul>

                <Button
                  asChild
                  size="lg"
                  className="w-full bg-blue-600 hover:bg-blue-700 text-white py-6 text-lg shadow-lg shadow-blue-600/25 hover:shadow-blue-600/40 transition-all"
                >
                  <a href="#contacto">Solicitar Ahora</a>
                </Button>

                <p className="text-center text-sm text-slate-500 mt-4">
                  Pago por Yape, Plin o transferencia
                </p>
              </CardContent>
            </Card>
          </div>

          {/* Testimonials */}
          <div className="space-y-6">
            <h3 className="text-2xl font-bold text-slate-800 mb-6">
              Lo que dicen nuestros estudiantes
            </h3>
            {testimonials.map((testimonial) => (
              <Card
                key={testimonial.id}
                className="border-slate-200 hover:border-blue-200 hover:shadow-lg transition-all duration-300"
              >
                <CardContent className="p-6">
                  <div className="flex gap-1 mb-4">
                    {[...Array(testimonial.rating)].map((_, i) => (
                      <Star key={i} className="w-5 h-5 fill-amber-400 text-amber-400" />
                    ))}
                  </div>
                  <p className="text-slate-700 mb-4 italic">
                    "{testimonial.comment}"
                  </p>
                  <div className="flex items-center gap-3">
                    <div className="w-10 h-10 rounded-full bg-blue-100 text-blue-600 flex items-center justify-center font-semibold">
                      {testimonial.name.charAt(0)}
                    </div>
                    <div>
                      <div className="font-semibold text-slate-800">{testimonial.name}</div>
                      <div className="text-sm text-slate-500">{testimonial.university}</div>
                    </div>
                  </div>
                </CardContent>
              </Card>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
};

export default Pricing;
